<template>
  <div class="chat-chart">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "ChatChart",
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    renderChart() {
      if (!this.config || !this.$refs.canvas) {
        return;
      }

      this.destroyChart();

      const ctx = this.$refs.canvas.getContext("2d");
      const datasets = (this.config.datasets || []).map((dataset) => ({
        ...dataset,
        backgroundColor: dataset.backgroundColor || "#5e72e4",
        borderColor: dataset.borderColor || dataset.backgroundColor || "#5e72e4",
        borderWidth: dataset.borderWidth ?? 1,
      }));

      this.chartInstance = new Chart(ctx, {
        type: this.config.type || "bar",
        data: {
          labels: this.config.labels || [],
          datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: this.config.type === "doughnut" ? 1.5 : 2,
          plugins: {
            legend: {
              display: datasets.length > 1 || this.config.type === "doughnut",
              position: "bottom",
              labels: {
                boxWidth: 12,
                font: { size: 11 },
              },
            },
            title: {
              display: Boolean(this.config.title),
              text: this.config.title || "",
              font: { size: 13, weight: "600" },
              padding: { bottom: 8 },
            },
          },
          scales:
            this.config.type === "doughnut" || this.config.type === "pie"
              ? {}
              : {
                  x: {
                    ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
                    grid: { display: false },
                  },
                  y: {
                    beginAtZero: true,
                    ticks: { precision: 0, font: { size: 10 } },
                  },
                },
          ...(this.config.options || {}),
        },
      });
    },
  },
};
</script>

<style scoped>
.chat-chart {
  margin-top: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e9ecef;
  max-width: 100%;
}

.chat-chart canvas {
  max-height: 260px;
}
</style>
